import React from "react"
import "./ShipmentAddTrack.scss"
import ShipmentAddTrackSimple from "../ShipmentAddTrackSimple/ShipmentAddTrackSimple";
// import ShipmentAddTrackDetailed from "../ShipmentAddTrackDetailed/ShipmentAddTrackDetailed";

const ShipmentAddTrack = ({ refetch, close, mixpanel, onTabChange }) => {
  return (
    <div className="ShipmentAddTrack">
      <ShipmentAddTrackSimple refetch={refetch} close={close} mixpanel={mixpanel} onTabChange={onTabChange} />
      {/* <div className="separator" />
      <ShipmentAddTrackDetailed refetch={refetch} close={close} /> */}
    </div>
  )
}

export default ShipmentAddTrack;
